import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import { ClarifyingQuestion } from '../helpers';

interface ClarifyingQuestionsProps {
  questions: ClarifyingQuestion[];
}

export function ClarifyingQuestions({ questions }: ClarifyingQuestionsProps) {
  if (!questions || questions.length === 0) {
    return null;
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5, mt: 1 }}>
      {questions.map((item, idx) => (
        <Paper
          key={idx}
          sx={{
            p: 2,
            border: '1px solid #EAECF0',
            borderRadius: '12px',
            backgroundColor: '#FAFAFA',
          }}
        >
          <Typography 
            variant="body2" 
            sx={{ 
              fontSize: 16, 
              fontWeight: 600,
              mb: 0.5,
              whiteSpace: 'pre-wrap', 
              wordBreak: 'break-word' 
            }}
          >
            {item.question}
          </Typography>
          {item.context && (
            <Typography 
              variant="body2" 
              sx={{ 
                fontSize: 14, 
                color: '#667085',
                whiteSpace: 'pre-wrap', 
                wordBreak: 'break-word' 
              }}
            >
              {item.context}
            </Typography>
          )}
        </Paper>
      ))}
    </Box>
  );
}

